import React from 'react';

import PageHeader from '../components/header/page';
import ContentBlock from '../components/contentblock';
import ABBlock from '../components/contentblock/abblock';

import Senograph from '../resources/images/devices/senograph.jpg';
import Senograph2x from '../resources/images/devices/senograph@2x.jpg';

import './bkfp.scss'

const DevicesPage = props =>
  (<main>
    <a href="http://www.frueh-erkennen.at/">
      <PageHeader headline="Brustkrebs&shy;früherkennung"/>
    </a>
    <section className="container-custom">
          <ABBlock right img={Senograph} img2x={Senograph}>
            <ContentBlock title="Brustkrebs-Früherkennung &ndash; wichtig&nbsp;und&nbsp;gut">
              <p>
                Um österreichweit eine flächendeckende Versorgung für die Brustkrebs-Früherkennung anbieten zu können, 
              gibt es das „Österreichische Brustkrebs-Früherkennungsprogramm“ (BFKP). Wir, das Radiologiezentrum Bregenz, 
              sind Teil dieses wichtigen Netzwerkes. Damit das Programm auch immer auf neuestem Wissensstand durchgeführt wird, 
              müssen wir strenge Qualitätsvorgaben erfüllen:
              </p>
              <ul className="feature-list">
                <li>
                  Unsere Mitarbeiterinnen und Mitarbeiter werden laufend geschult.
                </li>
                <li>
                  Wir sind mit dem Zertifikat Mammadiagnostik der Österreichischen Ärztekammer ausgezeichnet.
                </li>
                <li>
                  Wir verwenden nur moderne, digitale Geräte, die laufend technisch überprüft werden. Die Mammografie-Bilder werden 
                  nach dem 4-Augen-Prinzip immer von zwei Radiologinnen bzw. Radiologen ausgewertet.
                </li>
              </ul>
              <p>Nur wenn wir all diese Qualitätskriterien erfüllen, dürfen wir Mammografien im Rahmen des Österreichischen Brustkrebs-Früherkennungsprogramms durchführen. Dies gilt auch für Mammografien bei Krankheitsverdacht.</p>
              <p>Ausführliche Informationen zum Brustkrebs-Früherkennungsprogramm erhalten sie auf der Internetseite: <a href="http://frueh-erkennen.at">www.frueh-erkennen.at</a></p>
            </ContentBlock>
          </ABBlock>
    </section>
    <div class="banner">
      <div class="banner-wrapper">
        <h1 class="banner-headline massive featured">Digitale Radiologie kann Leben retten.</h1>
        <a class="banner-link button" href="/contact">Vorsorgetermin vereinbaren</a>
      </div>
    </div>
  </main>);

export default DevicesPage;


// WEBPACK FOOTER //
// ./src/pages/bkfp.js